import IconButton from "..";
import { FeatureStatusIcon, UnfeatureStatusIcon } from "@/constant/imagePath";

const ChangeFeatureStatusButton = ({
  isActive = true,
  icon = !isActive ? FeatureStatusIcon : UnfeatureStatusIcon,
  borderColor = !isActive ? "#05A16D" : "#000000",
  fromColor = !isActive ? "#fffff" : "#fffff",
  toColor = !isActive ? "#fffff" : "#fffff",
  buttonStyle = { padding: "3.3px 2.5px" },
  onClick = null,
  tooltipText = !isActive ? "Feature" : "Unfeatured",
  ...props
}) => {
  return (
    <IconButton
      icon={icon}
      borderColor={borderColor}
      fromColor={fromColor}
      toColor={toColor}
      buttonStyle={buttonStyle}
      onClick={onClick}
      tooltipText={tooltipText}
      {...props}
    />
  );
};

export default ChangeFeatureStatusButton;
